import { render, staticRenderFns } from "./XTO.vue?vue&type=template&id=28163cfa&scoped=true&"
import script from "./XTO.vue?vue&type=script&lang=js&"
export * from "./XTO.vue?vue&type=script&lang=js&"
import style0 from "./XTO.vue?vue&type=style&index=0&id=28163cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28163cfa",
  null
  
)

export default component.exports